// The status rows the connected lists share (Ultime news, News salvate, Il mio feed):
// the loading state as card-shaped placeholders, and «Carica altre».
import { Button } from "@heroui/react";

import { STATUS_BUTTON_CLASS } from "../../components/PanelStatus";
import { NewsCardPlaceholder } from "../../components/news/NewsCardPlaceholder";

export const LOADING = "Caricamento delle news…";
export const MORE_FAILED = "Altre news non disponibili.";
export const REFRESH_FAILED = "Aggiornamento delle news non riuscito.";
/** How many card-shaped placeholders a loading list shows. */
const PLACEHOLDERS = 2;

/** The loading state of a list: card-shaped placeholders, named for assistive technology (by default, the news). */
export function ListLoading({ label = LOADING }: { label?: string } = {}) {
  return (
    <div role="status" aria-label={label} className="flex flex-col gap-[15px]">
      {Array.from({ length: PLACEHOLDERS }, (_, i) => (
        <NewsCardPlaceholder key={i} />
      ))}
    </div>
  );
}

/**
 * «Carica altre»: the label never changes, the wait shows as the disabled
 * button (also while the cards are stand-ins); placed as the row of actions
 * under a card's content: on the right, in the section's rhythm.
 */
export function LoadMore({ isDisabled, onPress }: { isDisabled: boolean; onPress: () => void }) {
  return (
    <div className="flex items-center justify-end">
      <Button size="sm" isDisabled={isDisabled} onPress={onPress} className={STATUS_BUTTON_CLASS}>
        Carica altre
      </Button>
    </div>
  );
}
